import axios from '@/utils/http';

export default (advertisementId, params) => {
  return axios
    .put(`/advertisement/${advertisementId}/edit`, params)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
